module.exports = __webpack_public_path__ + "img/pr-6.22b259e0.png";